import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";

import { type CollectionsStage, type ProductClientCollections } from "@fitness-app/data-models/entities/ProductClient";

import { productApi } from "~/store/initializeStore";

export type UpdateCollectionsStagePayload = {
  productClientId: string;
  stage: CollectionsStage;
  note?: string;
  /** null clears the planned contact date; omitted keeps it. */
  nextContactAt?: string | null;
};

/** Moves a client's collections case to a stage and logs the reason as a client note (TRE-2168). */
export const useUpdateCollectionsStage = () => {
  const queryClient = useQueryClient();
  const key = "updateCollectionsStage";

  return useMutation({
    mutationFn: async (payload: UpdateCollectionsStagePayload) => {
      message.loading({ content: "Zapisywanie etapu...", key });
      const response = await productApi.post<{ collections: ProductClientCollections }>(
        "/clients/collections-stage",
        payload,
      );
      return response.data;
    },
    onSuccess: () => {
      message.destroy(key);
      void message.success("Etap windykacji zapisany");
      void queryClient.invalidateQueries(["installmentCollectionStats"]);
    },
    onError: () => {
      message.destroy(key);
      void message.error("Nie udało się zapisać etapu windykacji");
    },
  });
};
